export enum QuestionnaireRegion {
  Luxembourg = 'LUX',
  Switzerland = 'CHE',
  Other = 'OTHER',
}

export enum QuestionnaireFieldInputType {
  Number = 'NUMBER',
  Text = 'TEXT',
}

export enum QuestionnaireFieldType {
  ShortText = 'SHORT_TEXT',
  LongText = 'LONG_TEXT',
  SingleSelect = 'SINGLE_SELECT',
  MultipleSelect = 'MULTIPLE_SELECT',
}

export interface QuestionnaireFieldTemplate {
  id: string;
  title: string;
  type: QuestionnaireFieldType;
  hint?: string;
  inputType?: QuestionnaireFieldInputType;
  placeholder?: string;
  selectableValues?: any;
}

export interface QuestionnaireTemplate {
  createdAt: Date;
  createdBy: string;
  fields: Array<QuestionnaireFieldTemplate>;
  id: number;
  name: string;
  region: QuestionnaireRegion;
  updatedAt: Date;
  updatedBy: string;
}

export interface QuestionnaireFieldAnswer {
  fieldId: string;
  answers: string[];
}
export interface CompletedQuestionnaire {
  questionnaireTemplateId: number;
  questionnaireFieldAnswers: QuestionnaireFieldAnswer[];
}
